
import { Button } from "@/components/ui/button";
import { Plane, GraduationCap, Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { COPY } from "@/content/copy";

const verticals = [
  {
    icon: Plane,
    title: "Travel",
    headline: "✈️ Travel",
    description: COPY.sublineByVertical.travel,
    gradient: "from-blue-500/20 to-cyan-500/20"
  },
  {
    icon: GraduationCap,
    title: "Education", 
    headline: "🎓 Education",
    description: COPY.sublineByVertical.education,
    gradient: "from-purple-500/20 to-pink-500/20"
  },
  {
    icon: Heart,
    title: "Healthcare",
    headline: "🏥 Healthcare",
    description: COPY.sublineByVertical.healthcare,
    gradient: "from-green-500/20 to-teal-500/20"
  },
];

const VerticalCardsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
            Built for Life's Big Moments
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Whatever matters most to you, Flexaura makes it affordable with flexible monthly payments from AED 2,000 to AED 200,000+
          </p>
          <p className="text-xs text-muted-foreground font-body mt-2">
            Eligibility and limits are determined by our partners.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {verticals.map((vertical, index) => (
            <div key={index} className="group bg-card rounded-2xl overflow-hidden card-shadow hover:elevated-shadow smooth-transition flex flex-col h-full">
              <div className={`bg-gradient-to-br ${vertical.gradient} p-6`}>
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <vertical.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-heading font-bold mb-2">
                  {vertical.headline}
                </h3>
                <p className="text-lg font-body text-foreground/80">
                  {vertical.description}
                </p>
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full hover:bg-flexaura-teal hover:text-white hover:border-flexaura-teal mt-auto"
                  onClick={() => {
                    // Navigate to the appropriate vertical page
                    const verticalPath = `/${vertical.title.toLowerCase()}`;
                    navigate(verticalPath);
                  }}
                >
                  Get Early Access
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerticalCardsSection;
